import "./ImageCard.scss";

function ImageCard(props) {

    return (

        <img className="card-img-top" src={props.src} alt={props.alt}/>

    )
}

export default ImageCard;